export default [
  {
    label: 'none',
  },
  {
    label: 'tsp',
  },
  {
    label: 'tbsp',
  },
  {
    label: 'oz',
  },
  {
    label: 'cup',
  },
  {
    label: 'kg',
  },
  {
    label: 'gr',
  },
  {
    label: 'mL',
  },
  {
    label: 'L',
  },
  {
    label: 'lb',
  },
  {
    label: 'drop',
  },
  {
    label: 'pinch',
  },
  {
    label: 'dash',
  },
  {
    label: 'pint',
  },
  {
    label: 'quart',
  },
  {
    label: 'pottle',
  },
  {
    label: 'gallon',
  },
  {
    label: '',
  },
];
